import React from 'react';
import './SpaceBackground.css';

function SpaceBackground() {
  return (
    <div className="ai-background">
      <div className="ai-background-base"></div>
      <div className="ai-background-grid"></div>
      <div className="ai-background-gradient"></div>
      <div className="ai-particles">
        {Array.from({ length: 20 }).map((_, i) => (
          <div
            key={i}
            className="ai-particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 4}s`,
              animationDuration: `${3 + Math.random() * 2}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default SpaceBackground;
